import { useTheme } from '@mui/material';

import { ImagePriorityContext } from '@/utils/images/imageOptimization';
import FocalPointImage from '@/components/FocalPointImage';
import ImageAsset from '@/components/ImageAsset';
import { IImage } from '@/components/ImageAsset/ImageAsset';
import { ImageAsset as TImageAsset, Maybe } from '@/types/generated';

import { BlogImage } from './BlogDetailsPage';

export default function BlogDetailsImageAssetContainer({
	imageAsset,
	blogImage,
	usePreloader,
	isSmallScreen,
}: {
	blogImage?: Maybe<BlogImage>;
	imageAsset?: Maybe<TImageAsset>;
	usePreloader?: boolean;
	isSmallScreen: boolean;
}) {
	const theme = useTheme();

	const desktopMobileID = isSmallScreen ? 'mobile' : 'desktop';

	return (
		(usePreloader && (
			<ImagePriorityContext.Provider value={1}>
				{imageAsset ? (
					<ImageAsset
						loading="eager"
						desktopImage={imageAsset?.desktopImage as IImage}
						mobileImage={imageAsset?.mobileImage as IImage}
						dataTestId="blog_detail_page_img_asset_focal_point_image_desktop"
					/>
				) : (
					<FocalPointImage
						loading="eager"
						brandFolderImage={blogImage?.image}
						focalPoint={blogImage?.focalPoint}
						sizes={`${theme.breakpoints.up('md').replace('@media', '')} 50vw, 100vw`}
						dataTestId="blog_detail_page_focal_point_image_desktop"
					/>
				)}
			</ImagePriorityContext.Provider>
		)) || (
			<>
				{imageAsset ? (
					<ImageAsset
						loading="eager"
						desktopImage={imageAsset?.desktopImage as IImage}
						mobileImage={imageAsset?.mobileImage as IImage}
						dataTestId={`blog_detail_page_img_asset_focal_point_image_${desktopMobileID}`}
					/>
				) : (
					<FocalPointImage
						loading="eager"
						brandFolderImage={blogImage?.image}
						focalPoint={blogImage?.focalPoint}
						sizes={`${theme.breakpoints.up('md').replace('@media', '')} 50vw, 100vw`}
						dataTestId={`blog_detail_page_focal_point_image_${desktopMobileID}`}
					/>
				)}
			</>
		)
	);
}
